import React from "react";
import { Link } from "react-router-dom";

export default function ReportingConcerns(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Reporting & Recording of concerns about suspected poor practices and/ or
        abuse
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            All SS staff and associates (including coaches, fellows, event
            organizing team etc.) are expected to individually and collectively
            be vigilant. On observing incidences of poor practices where child
            safety has been compromised or come to know of (or suspect)
            incidents of child abuse, however minor, shall report their concerns
            to SS Child Protection Officer without loss of time by a phone call
            and follow it up by filing a report with CPO as per format within 48
            hours. Deciding or judging the merits of the concern shall be
            avoided at this stage. In case of non-availability of CPO/SS for any
            reason, report by phone call can be made to any member of Child
            Safeguarding & Protection Group (CSPG) or Head-HR or CEO, SS/KVS.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Further, if any of the following occur, the SS staff should report
            this immediately to the Child Protection Officer, record the
            incident and file a written report. They should also ensure that the
            parents/teachers of the child are informed immediately:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                if a player/ program participant gets hurt during any event or
                coaching/ program/ tournament.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                if he/she appears distressed or traumatized in any manner
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                if a child appears abnormally quiet/ uncommunicative.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                if a child appears to be sexually disturbed by anyone’s actions
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                if a child appears to misunderstand or misinterpret something
                anyone have done.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                if suspected child abuse or other types of child protection
                concerns come to notice
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            The format for reporting and recording concerns/ incidences of poor
            practice and/or child abuse is at{" "}
            <Link
              to="/csppolicy/annexure5"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-yellow-500 hover:underline"
            >
              Annexure-5.
            </Link>
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            SS/KVS shall encourage all persons who attend SS/KVS’s workplaces/
            events/ activities to report any incidences of poor practice as well
            as any suspected or known incident of child abuse to Child
            Protection Officer (CPO), SS/KVS. This report can even be made by a
            telephone call. In such cases, CPO, SS/KVS shall make efforts to
            obtain the information in writing as per prescribed format failing
            which efforts will be made to collect as much information as
            possible from the person to help investigations. SS coaches and
            Head-HR shall also encourage visitors/ guests who attend SS
            workplaces/ events/ activities to familiarize themselves with this
            policy and adhere to it during their interaction with Slum Soccer
            program participants.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            In case the Slum Soccer/ Krida Vikas Sanstha’s Child Protection
            Officer or any member of Slum Soccer’s Child Safeguarding &
            Protection Group (CSPG) is the subject of the suspicion/allegation,
            the person reporting the Child Safeguarding & Protection (CSP)
            concerns may directly report it to CEO of Slum Soccer who will
            ensure impartial handling of the matter.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            In case the suspicion/allegation is against Head-HR or CEO, SS, or
            any Board and society members of Krida Vikas Sanstha, the person
            reporting the CSP concerns may directly reported it to the Child
            Welfare Committee of the district or to the Child Helpline number
            1098. Child Welfare Committee of Nagpur can be reached at email{" "}
            <a
              href="mailto:cwcnagpur26@gmail.com"
              className="text-yellow-500 hover:underline"
            >
              cwcnagpur26@gmail.com
            </a>
            , phone no.{" "}
            <a
              href="tel:+917122954746"
              className="text-yellow-500 hover:underline"
            >
              0712-2954746
            </a>
            .
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Even in cases where the person reporting the CSP concerns feels that
            the reported allegations/ concerns have not been addressed
            adequately by Slum Soccer/KVS, they may report the concerns to the
            Child Welfare Committee of the district.
          </span>
        </div>
      </div>
    </div>
  );
}
